export const invalid = (): never => {
  throw new TypeError("Invalid order-type contract")
}
const record = (value: unknown): Record<string, unknown> => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return invalid()

  return value as Record<string, unknown>
}
export const uuid = (value: unknown): string => {
  if (
    typeof value !== "string" ||
    !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
  )
    return invalid()

  return value
}
export const orderType = (value: unknown, organizationId: string): OrderType => {
  const input = record(value)

  if (
    input.organization_id !== organizationId ||
    typeof input.internal_label !== "string" ||
    typeof input.public_label !== "string" ||
    (input.description !== null && typeof input.description !== "string") ||
    (input.typical_duration_min !== null &&
      (!Number.isSafeInteger(input.typical_duration_min) ||
        Number(input.typical_duration_min) < 1)) ||
    typeof input.is_standard_type !== "boolean" ||
    typeof input.is_protected !== "boolean" ||
    (input.key !== null && typeof input.key !== "string") ||
    typeof input.created_at !== "string" ||
    !Number.isFinite(Date.parse(input.created_at)) ||
    typeof input.updated_at !== "string" ||
    !Number.isFinite(Date.parse(input.updated_at))
  )
    return invalid()

  return {
    id: uuid(input.id),
    organization_id: organizationId,
    internal_label: input.internal_label,
    public_label: input.public_label,
    description: input.description as string | null,
    typical_duration_min: input.typical_duration_min as number | null,
    is_standard_type: input.is_standard_type,
    is_protected: input.is_protected,
    key: input.key as string | null,
    created_at: input.created_at,
    updated_at: input.updated_at,
  }
}
export const draft = (value: OrderTypeUpdatePayload): OrderTypeUpdatePayload => {
  const input = record(value)

  if (
    Object.keys(input).some(
      (key) =>
        ![
          "internal_label",
          "public_label",
          "description",
          "typical_duration_min",
          "is_standard_type",
        ].includes(key),
    )
  )
    return invalid()

  for (const field of ["internal_label", "public_label"] as const) {
    const label = input[field]

    if (
      label !== undefined &&
      (typeof label !== "string" || label.trim().length < 2 || label.length > 200)
    )
      return invalid()
  }

  if (
    (input.description !== undefined &&
      input.description !== null &&
      typeof input.description !== "string") ||
    (input.typical_duration_min !== undefined &&
      input.typical_duration_min !== null &&
      (!Number.isSafeInteger(input.typical_duration_min) ||
        Number(input.typical_duration_min) < 1)) ||
    (input.is_standard_type !== undefined && typeof input.is_standard_type !== "boolean")
  )
    return invalid()

  return { ...value }
}
export const restoreResult = (value: unknown) => {
  const input = record(value)

  if (
    !Number.isSafeInteger(input.created) ||
    Number(input.created) < 0 ||
    !Number.isSafeInteger(input.updated) ||
    Number(input.updated) < 0
  )
    return invalid()

  return { created: input.created as number, updated: input.updated as number }
}
